import {
    AfterViewInit,
    ChangeDetectionStrategy,
    Component,
    ElementRef,
    EventEmitter,
    Input,
    OnDestroy,
    Output,
    ViewChild
} from '@angular/core';
import { BaTypeahead } from '@design/bapf-pattern-library';
import { I18NextPipe } from '@kokos-i18next';

@Component({
    selector: 'pf-typeahead',
    standalone: true,
    imports: [
        I18NextPipe
    ],
    templateUrl: './typeahead.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
})
export class TypeaheadComponent implements AfterViewInit, OnDestroy {

    @Input() name!: string;
    @Input() label!: string;
    @Input() options: { label: string; value: string }[] = [];
    @Input() extraInfos?: string;
    @Output() selected = new EventEmitter<string>();

    @ViewChild('patternRoot', { static: true })
    patternRoot!: ElementRef<HTMLElement>;

    private baTypeaheadInstance: BaTypeahead | null = null;

    ngAfterViewInit(): void {
        this.initTypeahead();
    }

    ngOnDestroy(): void {
        if (this.baTypeaheadInstance) {
            this.baTypeaheadInstance.destroy();
            this.baTypeaheadInstance = null;
        }
    }

    private initTypeahead(): void {
        const rootEl = this.patternRoot.nativeElement;

        this.baTypeaheadInstance = new BaTypeahead(rootEl, {
            suggestions: async (search: unknown): Promise<any[]> => {
                const s = typeof search === 'string' ? search : '';
                const term = s.trim().toLowerCase();
                if (!term) {
                    return [];
                }
                return this.options
                    .filter(o => o.label.toLowerCase().includes(term))
                    .map(o => ({
                        term: o.label,
                        value: o.value
                    }));
            },
            filter: false,
            selectCallback: (entry: any) => {
                const selectedValue: string =
                    entry?.value ??
                    this.options.find(o => o.label === entry?.term)?.value ??
                    entry?.term;
                this.selected.emit(selectedValue);
            }
        });
    }
}